module.exports = __webpack_public_path__ + "06_mustache_silver.df27ff71.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/06_mustache_silver.png
// module id = nBwb
// module chunks = 0